
import { Component, Vue } from 'vue-property-decorator';
import Notification from './Notification.vue';
import bus from '@/lib/event_bus';

@Component({
  components: {
    Notification,
  },
})
export default class Notifications extends Vue {
  private notificationList: object[] = [];
  private incrementalIndex: number = 0;

  private created() {
    bus.$on('notify', this.sendNotification);
  }

  private closeNotification(event: Event, index: number) {
    this.notificationList.splice(index, 1);
  }

  private sendNotification(notification: any) {
    notification = {
      id: this.incrementalIndex++,
      ...notification,
    };
    // OLD: unconditional push — same error repeated (e.g. wrong OTP multiple times) stacked into a flood
    // NEW: if identical title+message already visible, replace it (restarts auto-close timer) instead of stacking
    const existingIndex = this.notificationList.findIndex(
      (n: any) =>
        n.title === notification.title && n.message === notification.message
    );
    if (existingIndex !== -1) {
      this.$set(this.notificationList, existingIndex, notification);
    } else {
      this.notificationList.push(notification);
    }
  }

  private beforeDestroy() {
    bus.$off('notify');
  }
}
